import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import symbolFontParams from 'pxc-editor-data/d/symbolFontParams';
import symbolsConfig from 'pxc-editor-data/d/toc.json';
import { updateSelectedSectionsProps } from '@/actions';
import { filterSelectedSectionsForMode, getSymbolCategoryByMaterial } from '@/helpers';
import InsertSymbolForm from './InsertSymbolForm';

const InsertSymbolFormWebComponentContainer = (props) => {
  const {
    mode,
    pages,
    shieldsSelection,
    sectionsSelection,
    updateSelectedSectionsProps,
    verticalAlignment,
    horizontalAlignment
  } = props;
  const symbolsList = symbolsConfig;
  
  const [defaultData, setDefaultData] = useState(null);

  useEffect(() => {
    const data = buildDefaultData(mode, pages, shieldsSelection, sectionsSelection);
    setDefaultData(data);
  }, [mode, pages, sectionsSelection, shieldsSelection]);

  const handleChange = (data) => {
    if (!!Object.keys(sectionsSelection).length || !!Object.keys(shieldsSelection).length) {
      updateSelectedSectionsProps(data);
    }
  }

  return defaultData && (
    <InsertSymbolForm
      symbolsList={symbolsList}
      symbolFontParams={symbolFontParams}
      {...defaultData}
      verticalAlignment={verticalAlignment}
      horizontalAlignment={horizontalAlignment}
      onChange={handleChange}
    />
  )
};

const mapStateToProps = state => ({
  mode: state.core.mode,
  pages: state.core.pages,
  sectionsSelection: state.core.sectionsSelection,
  shieldsSelection: state.core.shieldsSelection,
});

const mapDispatchToProps = dispatch => ({
  updateSelectedSectionsProps: (changedProp) => dispatch(updateSelectedSectionsProps(changedProp)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    horizontalAlignment,
    verticalAlignment
  } = ownProps?.props;

  const props = {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    horizontalAlignment: horizontalAlignment,
    verticalAlignment: verticalAlignment,
  };

  return props;
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(InsertSymbolFormWebComponentContainer);

const buildDefaultData = (mode, pages, shieldsSelection, sectionsSelection) => {
  const [sectionsToFormat] = filterSelectedSectionsForMode(mode, pages, shieldsSelection, sectionsSelection);

  if (sectionsToFormat?.glyph) {
    return { symbolFont: sectionsToFormat.symbolFont, symbol: sectionsToFormat.glyph };
  } else {
    return { symbolFont: getSymbolCategoryByMaterial(), symbol: null };
  }
};